// ─── AFK auto (Electron uniquement) ──────────────────────────────────────────
// Bascule le statut sur « absent » après une période d'inactivité système
// (clavier+souris au repos toutes apps confondues), et restaure au retour.
//
// Règles intelligentes pour ne pas écraser un choix manuel :
//   • Au DÉPART AFK : on ne bascule QUE si le statut courant est « enligne ».
//     Si l'utilisateur a explicitement choisi « occupe » ou « invisible »,
//     on respecte son intention et on ne touche à rien.
//   • Au RETOUR : on ne restaure QUE si le statut courant est encore « absent »
//     (= celui qu'on avait posé). Si l'utilisateur l'a changé entre-temps,
//     son choix prime, on ne touche pas.
//
// L'API Electron qui détecte l'inactivité (`powerMonitor`) n'existe pas dans
// un navigateur classique → ce module ne fait rien hors Electron.

// Mémorise le statut d'avant la bascule auto, pour pouvoir le restaurer.
let _avantAFK = null;

function _statutActuel() {
    const badge = document.getElementById('self-status-badge');
    if (!badge) return null;
    for (const cls of badge.classList) {
        if (cls.startsWith('status-')) return cls.replace('status-', '');
    }
    return null;
}

function _appliquerStatut(nouveau) {
    if (typeof window.changerStatut === 'function') window.changerStatut(nouveau);
}

export function initAfkAuto() {
    if (!window.chaosNative || typeof window.chaosNative.onIdleStateChange !== 'function') {
        // Pas en Electron (ou ancien build sans le pont) → on ne fait rien.
        return;
    }
    window.chaosNative.onIdleStateChange(({ idle }) => {
        const actuel = _statutActuel();
        if (idle) {
            // Bascule en AFK : uniquement si l'utilisateur est en « enligne ».
            if (actuel === 'enligne') {
                _avantAFK = actuel;
                _appliquerStatut('absent');
            }
        } else {
            // Retour : ne restaure que si on avait posé « absent » et qu'il
            // est toujours là (sinon l'utilisateur a changé entre-temps).
            if (_avantAFK && actuel === 'absent') {
                _appliquerStatut(_avantAFK);
            }
            _avantAFK = null;
        }
    });
}
